import { defineMessages } from 'react-intl';

const messages = defineMessages({
  plates: {
    id: 'plates',
    defaultMessage: 'Plates'
  },
  edit: {
    id: 'edit',
    defaultMessage: 'Edit'
  },
  remove: {
    id: 'remove',
    defaultMessage: 'Remove'
  }
});

export default messages;
